import MainRiskProfile from "../components/riskProfile/MainRiskProfile";

function PerfilDeRiesgo() {
  return <MainRiskProfile />;
}

export default PerfilDeRiesgo;
